import {Booking} from "../api-booking/Booking";
import {Invoice} from "../api-invoice/Invoice";
import {User} from "./User";

export enum CustomerGender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  UNDEFINED = "UNDEFINED"
}

export enum JobActivityRevenueType {
  SALARY = "SALARY",
  FAMILY_SUPPORT = "FAMILY_SUPPORT",
  WORKING_COMPENSATION = "WORKING_COMPENSATION",
  THIRD_PARTY_SUPPORT = "THIRD_PARTY_SUPPORT",
  PERSONAL_SAVINGS = "PERSONAL_SAVINGS",
  TRAINING_ALLOWANCE = "TRAINING_ALLOWANCE",
  SCHOLARSHIP = "SCHOLARSHIP",
}

export interface CustomerActivity {
  id: string;
  dateAdd: number;
  dateUpd: number;
  jobActivityIsMain: boolean;
  jobActivityIntention: string;
  jobActivityEmployerName: string;
  jobActivityAddress1: string;
  jobActivityAddress2: string;
  jobActivityZipCode: string;
  jobActivityCity: string;
  jobActivityState: string;
  jobActivityCountry: string;
}

export interface CustomerDocument {
  id: string;
  dateAdd: number;
  dateUpd: number;
  enabled: boolean;
  fileVersion: string;
  fileName: string;
  documentName: string;
  fileType: string;
  fileUrl: string;
  fileVerified: boolean;
  fileVerifiedTime: number;
  fileVerifiedBy: User;
}

export interface CustomerBooking {
  id: string;
  externalId: number;
  ceriId: number;
  customerFirstName: string;
  customerBookings: Booking[];
}

export interface CustomerInvoice {
  id: string;
  externalId: number;
  ceriId: number;
  customerFirstName: string;
  customerInvoices: Invoice[];
}

export interface CustomerNotification {
  id: string;
  dateAdd: number;
  dateUpd: number;
  ceriId: number;
  notificationContent: string;
  notificationSubject: string;
  notificationSent: boolean;
  notificationMarkRead: boolean;
  notificationMarkReadDate: number;
  notificationSentDate: number;
  notificationCustomer?: Customer;
}

export class Customer {
  static readonly ANONYMOUS: Customer = new Customer('', '');

  constructor(
    readonly customerFullName: string,
    readonly customerEmail: string,
    readonly customerImageUrl?: string | null,
    readonly id?: string,
    readonly dateAdd?: number,
    readonly dateUpd?: number,
    readonly enabled?: boolean,
    readonly externalId?: number,
    readonly ceriId?: number,
    readonly customerFirstName?: string,
    readonly customerLastName?: string,
    readonly customerPhone?: string,
    readonly customerBirthdate?: number,
    readonly customerBirthTown?: string,
    readonly customerNationality?: string,
    readonly customerGender?: CustomerGender,
    readonly customerType?: string,
    readonly customerCategory?: string,
    readonly customerPreferredLanguageCode?: string,
    readonly customerSource?: string,
    readonly customerAddress1?: string,
    readonly customerAddress2?: string,
    readonly customerZipCode?: string,
    readonly customerCity?: string,
    readonly customerState?: string,
    readonly customerCountry?: string,
    readonly customerResidenceId?: string,
    readonly customerResidenceCeriId?: number,
    readonly customerRevenueType?: JobActivityRevenueType,
    readonly customerRevenuePerMonth?: number,
    readonly customerRevenueN1?: number,
    readonly customerRevenueN2?: number,
    readonly customerLiabilityInsuranceReminder?: boolean,
    readonly customerPropertyInsuranceReminder?: boolean,
    readonly customerActivities?: CustomerActivity[],
    readonly customerDocuments?: CustomerDocument[],
    readonly customerRequests?: any[],
    readonly customerNotificationMail?: boolean,
    readonly customerNotificationSms?: boolean,
    readonly customerBeneficiaryNumber?: string,
    readonly customerBankName?: string,
    readonly customerBankCountryCode?: string,
    readonly customerBankIBAN?: string,
    readonly customerBankBIC?: string,
    readonly customerBankSEPARum?: string,
    readonly customerBankSEPAUnique?: string,
    readonly customerBankSEPADateSigned?: number,
    readonly customerBankSEPAAuthorized?: string,
    readonly customerLiabilityInsurance?: string,
    readonly customerLiabilityInsuranceDateEnd?: number,
    readonly customerPropertyInsurance?: string,
    readonly customerPropertyInsuranceDateEnd?: number,
    readonly customerAuthId?: string,
  ) { }

  public get isAuthenticated(): boolean {
    return !!this.customerEmail;
  }

}
